const PUBLIC_ROUTES = {
  LOGIN: '/login',
  MAGIC_LINK: '/login/link',
  RECOVER_PASSWORD: '/recover-password',
};

export const PRIVATE_ROUTES = {
  HOME: '/home',
  HOME_APPOINTMENT_DETAIL: '/home/appointments/:id',
  PROFILE_SETUP: '/profile-setup',
  PROFILE: '/profile',
  PATIENTS: '/patients',
  PATIENT_APPOINTMENT: '/patients/:id/appointment',
  PATIENT_PROFILE: '/patients/:id/profile',
  APPOINTMENTS: '/appointments',
  APPOINTMENT_DETAIL: '/appointments/:id',
  APPOINTMENTS_RESERVE: '/appointments/reserve',
  APPOINTMENTS_SUCCESS: '/appointments/success',
  BILLING: '/billing',
  DOCS: '/docs',
  ADMINISTRATORS: '/administrators',
  METRICS: '/metrics',
  NOTIFICATIONS: '/notifications',
  CHAT: '/chat',
  CHAT_SUPPORT: '/chat?support=true',
};

export const ROUTES = {
  ROOT: '/',
  ...PUBLIC_ROUTES,
  ...PRIVATE_ROUTES,
};
